import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetCrmProductDetailResponseDto } from "../../dtos/crm-product-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetCrmProductDetailQueryProps = {
  productId: string;
  options?: Omit<UseQueryOptions<GetCrmProductDetailResponseDto>, "queryKey">;
};

export const useGetCrmProductDetailQuery = ({
  productId,
  options
}: UseGetCrmProductDetailQueryProps) => {
  return useQuery({
    queryKey: ProductQueryKeys.getCrmProductDetail({ productId }).queryKey,
    queryFn: async () =>
      await ProductService.getCrmProductDetail({
        payload: { productId }
      }),
    ...options
  });
};
